import React from "react";
import { useParams } from "react-router-dom";
import { MarkListStudent } from "../../components/MarkListStudent";
import PublicLayout from "../../components/shared/PublicLayout/PublicLayout";

const PublicMarkListStudentPage = () => {
  const { id } = useParams();
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <PublicLayout>
        <MarkListStudent id={id} />
      </PublicLayout>
    </div>
  );
};

export default PublicMarkListStudentPage;
